(function () {
  function isThemeEditor() {
    return typeof Shopify !== 'undefined' && !!Shopify.designMode;
  }

  function isProductPage(root) {
    if (root) return !!root;
    var canonical = document.querySelector('link[rel="canonical"]');
    return (
      location.pathname.indexOf('/products/') !== -1 ||
      (canonical && canonical.href.indexOf('/products/') !== -1) ||
      !!document.querySelector('product-info')
    );
  }

  function isBraceletPage(root) {
    var url = (root && root.getAttribute('data-url')) || location.pathname;
    var canonical = document.querySelector('link[rel="canonical"]');
    return (
      url.indexOf('/products/silver-925-bracelet') !== -1 ||
      (canonical && canonical.href.indexOf('/products/silver-925-bracelet') !== -1)
    );
  }

  function textFrom(node) {
    return (node && node.textContent ? node.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function moneyFromPriceBox(priceBox) {
    if (!priceBox) return '';
    var sale = priceBox.querySelector('.price-item--sale');
    var regular = priceBox.querySelector('.price-item--regular');
    var any = sale || regular || priceBox.querySelector('.price-item');
    return any ? textFrom(any) : '';
  }

  function selectedVariantLabel(root) {
    var selected = root.querySelector('variant-selects [data-selected-value]');
    if (selected && selected.textContent.trim()) return selected.textContent.trim();

    var checked = root.querySelector('variant-selects input[type="radio"]:checked + label');
    if (checked && checked.textContent.trim()) return checked.textContent.trim();

    var select = root.querySelector('variant-selects select');
    if (select && select.selectedOptions && select.selectedOptions[0]) {
      return select.selectedOptions[0].textContent.trim();
    }

    return textFrom(root.querySelector('.product__title h1')) || 'Selected';
  }

  function hideLegacyNodes(root) {
    root
      .querySelectorAll(
        '.nl-bracelet-details, .nl-bracelet-details-v2, .nl-bracelet-sticky-cta, .nl-bracelet-sticky-cta-v2, .nl-bracelet-choice-note, .nl-bracelet-subtitle, .nl-bracelet-proofline, .nl-bracelet-fit, .nl-pdp-ship, .nl-pdp-why, .nl-pdp-variant-note'
      )
      .forEach(function (node) {
        node.remove();
      });
  }

  function moveAfter(node, target) {
    if (!node || !target || !target.parentNode || node === target.nextElementSibling) return;
    target.parentNode.insertBefore(node, target.nextSibling);
  }

  function directChildFor(node, parent) {
    if (!node || !parent) return node;
    var current = node;
    while (current && current.parentElement && current.parentElement !== parent) {
      current = current.parentElement;
    }
    return current || node;
  }

  function getPageLanguage() {
    var lang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (lang) return lang.split('-')[0];
    var pathLang = (location.pathname.split('/')[1] || '').toLowerCase();
    return pathLang || 'en';
  }

  function getFreeShippingLocale(language) {
    var locales = {
      de: 'de-DE',
      es: 'es-MX',
      fr: 'fr-FR',
      it: 'it-IT',
      pt: 'pt-PT',
    };
    return locales[language] || 'en-US';
  }

  function getFreeShippingCopyTemplate(language) {
    var templates = {
      de: 'Kostenloser Versand ab {amount}',
      es: 'Envio gratis desde {amount}',
      fr: 'Livraison gratuite des {amount}',
      it: 'Spedizione gratuita da {amount}',
      pt: 'Envio gratis a partir de {amount}',
    };
    return templates[language] || 'Free shipping over {amount}';
  }

  function formatFreeShippingThreshold(amount, currency, language) {
    var rounded = Math.round(amount);
    var locale = getFreeShippingLocale(language);

    if (currency === 'USD') return language === 'en' ? '$69' : '$69 USD';

    if (currency === 'MXN') {
      try {
        return (
          '$' +
          new Intl.NumberFormat('es-MX', {
            maximumFractionDigits: 0,
          }).format(rounded) +
          ' MXN'
        );
      } catch (error) {
        return '$' + rounded + ' MXN';
      }
    }

    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
      }).format(rounded);
    } catch (error) {
      return rounded + ' ' + currency;
    }
  }

  function getFreeShippingAnnouncement() {
    var language = getPageLanguage();
    var currencyData = typeof Shopify !== 'undefined' && Shopify.currency ? Shopify.currency : {};
    var currency = (currencyData.active || 'USD').toUpperCase();
    var rate = Number(currencyData.rate) || 1;
    var amount = currency === 'USD' ? 69 : 69 * rate;
    var threshold = formatFreeShippingThreshold(amount, currency, language);

    return getFreeShippingCopyTemplate(language).replace('{amount}', threshold);
  }

  function updateAnnouncementBar() {
    var message = getFreeShippingAnnouncement();

    document.querySelectorAll('.announcement-bar__message span').forEach(function (node) {
      if (!node) return;

      var current = (node.textContent || '').trim();
      if (
        /free shipping|env[ií]o gratis|livraison gratuite|kostenloser versand|spedizione gratuita|envio gr[aá]tis/i.test(
          current
        )
      ) {
        node.textContent = message;
      }
    });
  }

  function getShippingCopy() {
    var language = getPageLanguage();
    var copies = {
      es: {
        title: 'Envio e impuestos',
        aria: 'Envio e impuestos',
        items: [
          '<strong>Enviado desde China</strong> en 1-3 dias habiles.',
          '<strong>Entrega en 8-15 dias habiles</strong> a Mexico, EE. UU. y paises europeos seleccionados.',
          '<strong>Aranceles de importacion cubiertos</strong> por Nolimit para destinos compatibles.',
        ],
        link: 'Ver politica de envio completa',
      },
      fr: {
        title: 'Livraison et droits',
        aria: 'Livraison et droits',
        items: [
          '<strong>Expedie depuis la Chine</strong> en 1-3 jours ouvres.',
          '<strong>Livraison en 8-15 jours ouvres</strong> vers les Etats-Unis, le Mexique et certains pays europeens.',
          '<strong>Droits d importation couverts</strong> par Nolimit pour les destinations prises en charge.',
        ],
        link: 'Voir la politique de livraison',
      },
      de: {
        title: 'Versand und Zolle',
        aria: 'Versand und Zolle',
        items: [
          '<strong>Versand aus China</strong> innerhalb von 1-3 Werktagen.',
          '<strong>8-15 Werktage Lieferzeit</strong> in die USA, nach Mexiko und in ausgewahlte europaische Lander.',
          '<strong>Einfuhrabgaben ubernimmt Nolimit</strong> fur unterstutzte Ziele.',
        ],
        link: 'Versandrichtlinie ansehen',
      },
      it: {
        title: 'Spedizione e dazi',
        aria: 'Spedizione e dazi',
        items: [
          '<strong>Spedito dalla Cina</strong> in 1-3 giorni lavorativi.',
          '<strong>Consegna in 8-15 giorni lavorativi</strong> verso Stati Uniti, Messico e paesi europei selezionati.',
          '<strong>Dazi di importazione coperti</strong> da Nolimit per destinazioni supportate.',
        ],
        link: 'Vedi la politica di spedizione',
      },
    };

    return (
      copies[language] || {
        title: 'Shipping & duties',
        aria: 'Shipping and duties',
        items: [
          '<strong>Ships from China</strong> within 1-3 business days.',
          '<strong>8-15 business days</strong> to the United States, Mexico, and selected European countries.',
          '<strong>Import duties covered</strong> by Nolimit for supported destinations.',
        ],
        link: 'View full shipping policy',
      }
    );
  }

  function ensureShippingCard(root, info) {
    if (!root || !info) return null;
    var copy = getShippingCopy();
    var existing = root.querySelector('.nl-shipping-card');
    if (existing) {
      existing.setAttribute('aria-label', copy.aria);
      return existing;
    }

    var card = document.createElement('section');
    card.className = 'nl-shipping-card';
    card.setAttribute('aria-label', copy.aria);
    card.innerHTML =
      '<h2>' +
      copy.title +
      '</h2><ul>' +
      copy.items
        .map(function (item) {
          return '<li>' + item + '</li>';
        })
        .join('') +
      '</ul><a href="/policies/shipping-policy">' +
      copy.link +
      '</a>';
    info.appendChild(card);
    return card;
  }

  function getRootState(root) {
    if (!root.__nlPdpState) {
      root.__nlPdpState = {
        initialized: false,
        scheduled: false,
        cleanup: [],
        stickySync: null,
        stickySetVisibility: null,
        thumbsReady: false,
      };
    }
    return root.__nlPdpState;
  }

  function cleanupRoot(root) {
    if (!root || !root.__nlPdpState) return;
    root.__nlPdpState.cleanup.forEach(function (fn) {
      try {
        fn();
      } catch (error) {}
    });
    delete root.__nlPdpState;
  }

  function reorderBuyingPath(root) {
    if (!isProductPage(root)) return;

    hideLegacyNodes(root);

    var info = root.querySelector('.product__info-container');
    var price = root.querySelector('[id^="price-"]');
    var brief = root.querySelector('[data-nl-pdp-brief]');
    var trust = root.querySelector('.nl-pdp-trust');
    var optionLabel = root.querySelector('.nl-pdp-stone-label');
    var variants = root.querySelector('variant-selects');
    var buyForm = root.querySelector('product-form');
    var buyBlock = directChildFor(buyForm, info);
    var quantity = root.querySelector('[id^="Quantity-Form-"]');
    var glance = root.querySelector('.nl-pdp-glance');
    var installmentForm = root.querySelector('form.installment');
    var installmentWrapper =
      installmentForm && installmentForm.parentElement && installmentForm.parentElement !== info
        ? installmentForm.parentElement
        : installmentForm;

    if (!info || !price) return;

    var shippingCard = ensureShippingCard(root, info);
    var anchor = price;
    function place(node) {
      if (!node || !anchor) return;
      moveAfter(node, anchor);
      anchor = node;
    }

    if (quantity && buyBlock) quantity.classList.add('nl-quantity-after-buy');

    if (installmentWrapper && buyBlock) {
      installmentWrapper.classList.add('nl-pdp-installments');
      if (installmentForm) installmentForm.classList.add('nl-pdp-installment-form');
    }

    if (variants) place(optionLabel);
    place(variants);
    place(buyBlock);
    place(brief);
    place(trust);
    place(shippingCard);
    place(quantity);
    place(installmentWrapper);
    place(glance);

    root.classList.toggle('nl-bracelet-pdp', isBraceletPage(root));
  }

  function makeThumbSrc(img) {
    var src = img.currentSrc || img.getAttribute('src') || '';
    var srcset = img.getAttribute('srcset') || '';
    if (!src && srcset) src = srcset.split(',')[0].trim().split(' ')[0];
    if (!src) return '';
    src = src.replace(/^\/\//, 'https://');
    return src
      .replace(/([?&])width=\d+/i, '$1width=160')
      .replace(/([?&])w=\d+/i, '$1w=160');
  }

  function initMobileThumbs(root) {
    var state = getRootState(root);
    var gallery = root.querySelector('media-gallery');
    var list = root.querySelector('.product__media-list');
    if (!gallery || !list) return;

    var nativeThumbs = gallery.querySelector('.thumbnail-slider .thumbnail-list__item');
    var customThumbs = gallery.querySelector('.nl-mobile-thumbs');
    if (nativeThumbs) {
      if (customThumbs) customThumbs.remove();
      state.thumbsReady = false;
      return;
    }

    var slides = Array.prototype.slice
      .call(list.querySelectorAll('.product__media-item'))
      .filter(function (slide) {
        return !!slide.querySelector('img');
      });

    if (slides.length < 2) return;

    var thumbs = customThumbs;
    if (!thumbs) {
      thumbs = document.createElement('div');
      thumbs.className = 'nl-mobile-thumbs';
      thumbs.setAttribute('aria-label', 'Product image thumbnails');
      list.insertAdjacentElement('afterend', thumbs);
    }

    if (state.thumbsReady && thumbs.children.length === slides.length) return;

    thumbs.innerHTML = '';
    slides.forEach(function (slide, index) {
      var img = slide.querySelector('img');
      var button = document.createElement('button');
      var thumbImg = document.createElement('img');
      var src = makeThumbSrc(img);

      button.type = 'button';
      button.className = 'nl-mobile-thumb';
      button.setAttribute('aria-label', 'View image ' + (index + 1));
      if (index === 0) button.classList.add('is-active');

      thumbImg.src = src;
      thumbImg.alt = img.getAttribute('alt') || '';
      thumbImg.loading = 'lazy';
      button.appendChild(thumbImg);

      button.addEventListener('click', function () {
        slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        Array.prototype.forEach.call(thumbs.children, function (item) {
          item.classList.remove('is-active');
        });
        button.classList.add('is-active');
      });

      thumbs.appendChild(button);
    });

    if (!state.thumbsReady) {
      list.addEventListener(
        'scroll',
        function () {
          var closestIndex = 0;
          var closestDistance = Infinity;
          var listRect = list.getBoundingClientRect();

          slides.forEach(function (slide, index) {
            var rect = slide.getBoundingClientRect();
            var distance = Math.abs(rect.left - listRect.left);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });

          Array.prototype.forEach.call(thumbs.children, function (item, index) {
            item.classList.toggle('is-active', index === closestIndex);
          });
        },
        { passive: true }
      );
    }

    state.thumbsReady = true;
  }

  function initStickyBar(root) {
    var state = getRootState(root);
    var bar = root.querySelector('[data-nl-mobile-atc]');
    if (!bar) return;

    if (state.stickySync && state.stickySetVisibility) {
      state.stickySync();
      state.stickySetVisibility();
      return;
    }

    var submit = root.querySelector('[id^="ProductSubmitButton"]');
    var priceBox = root.querySelector('[id^="price-"]');
    var variantNode = bar.querySelector('[data-nl-sticky-variant]');
    var priceNode = bar.querySelector('[data-nl-sticky-price]');
    var trigger = bar.querySelector('[data-nl-sticky-submit]');

    function sync() {
      submit = root.querySelector('[id^="ProductSubmitButton"]') || submit;
      priceBox = root.querySelector('[id^="price-"]') || priceBox;
      if (variantNode) variantNode.textContent = selectedVariantLabel(root);
      if (priceNode) priceNode.textContent = moneyFromPriceBox(priceBox);
      if (trigger && submit) {
        trigger.disabled = submit.disabled;
        var label = submit.querySelector('span');
        if (label && label.textContent.trim()) trigger.textContent = label.textContent.trim();
      }
    }

    function setVisibility() {
      if (isThemeEditor()) {
        bar.classList.remove('is-visible');
        return;
      }
      if (!submit) return;
      var rect = submit.getBoundingClientRect();
      var belowBuyBox = rect.bottom < 0 || rect.top > window.innerHeight;
      var scrolled = window.scrollY > 420;
      bar.classList.toggle('is-visible', scrolled && belowBuyBox);
    }

    trigger &&
      trigger.addEventListener('click', function () {
        submit = root.querySelector('[id^="ProductSubmitButton"]') || submit;
        if (submit && !submit.disabled) submit.click();
      });

    state.stickySync = sync;
    state.stickySetVisibility = setVisibility;
    state.cleanup.push(function () {
      state.stickySync = null;
      state.stickySetVisibility = null;
    });

    if (!isThemeEditor()) {
      window.addEventListener('scroll', setVisibility, { passive: true });
      window.addEventListener('resize', setVisibility);
      state.cleanup.push(function () {
        window.removeEventListener('scroll', setVisibility, { passive: true });
        window.removeEventListener('resize', setVisibility);
      });

      var observer = new MutationObserver(function () {
        scheduleUpdate(root);
      });
      observer.observe(root, { childList: true, subtree: true });
      state.cleanup.push(function () {
        observer.disconnect();
      });
    }

    sync();
    setVisibility();
  }

  function scheduleUpdate(root) {
    if (!root) return;
    var state = getRootState(root);
    if (state.scheduled) return;
    state.scheduled = true;
    requestAnimationFrame(function () {
      state.scheduled = false;
      reorderBuyingPath(root);
      initMobileThumbs(root);
      initStickyBar(root);
      if (state.stickySync) state.stickySync();
      if (state.stickySetVisibility) state.stickySetVisibility();
    });
  }

  function initRoot(root) {
    if (!root || !isProductPage(root)) return;
    var state = getRootState(root);
    if (!state.initialized) state.initialized = true;
    scheduleUpdate(root);
  }

  function init() {
    updateAnnouncementBar();
    document.querySelectorAll('product-info').forEach(function (root) {
      initRoot(root);
    });
  }

  if (window.__nlPdpConversionV2Booted) return;
  window.__nlPdpConversionV2Booted = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll('product-info').forEach(function (root) {
      cleanupRoot(root);
    });
  });
  document.addEventListener('change', function () {
    setTimeout(init, 80);
  });
  document.addEventListener('variant:change', function () {
    setTimeout(init, 80);
  });
  setTimeout(init, 400);
  setTimeout(init, 1400);
})();
